import { GET_PAGES } from "./getPages";
import { GET_MENU } from "./getMenu";
import { GET_MEDIA_ITEM_BY_SLUG } from "./getImagesBySlug";
import { GET_HOME_HERO_BY_SLUG } from "./getHomeHeroBySlug";
import { GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG } from "./getFourColumnsRounded";
import { GET_TWO_COLUMS_TEXT_LEFT_BY_SLUG } from "./getTwoColumnsTextLeft";
import { GET_TWO_COLUMS_TEXT_RIGHT_BY_SLUG } from "./getTwoColumnsTextRight";
import { GET_VIDEO_BY_SLUG } from "./getVideoBySlug";
import { GET_POSTS } from "./getPosts";
import { GET_FOOTER } from "./getFooter";
import { GET_THREE_COLUMNS_CARDS } from "./getThreeColumnsCards";
import { GET_CAROUSELL_BY_SLUG } from "./getCarousellBySlug";
import { GET_POST_LIST } from "./getPostList";
import { GET_POST_DETAIL } from "./getPostDetail";
import { GET_MARKETS, GET_MARKET_PAYMENT_METHODS } from "./getMarkets";
import { GET_PAYMENT_METHOD_SECTION } from "./getPaymentMethodSection";
import { GET_TWO_COLUMS_TEXT_BY_SLUG } from "./getTwoColumnsText";
import { GET_FORM_SECTION_BY_SLUG } from "./getFormSectionBySlug";
import { GET_TWO_COLUMS_IMAGE_BY_SLUG } from "./getTwoColumnsImage";
import { GET_TERMS_AND_CONDITIONS } from "./getTermsAndConditions"
import { GET_FAQS } from "./getFaqs";
import { GET_PRIVACY_POLICIES } from "./getPrivacyPolicies";
import { GET_SEO_DATA } from "./getSectionSeoBySlug";
import { GET_FLOATING_BANNER } from "./getFloatingBanner";

export { 
    GET_PAGES, 
    GET_MENU, 
    GET_MEDIA_ITEM_BY_SLUG, 
    GET_HOME_HERO_BY_SLUG, 
    GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG, 
    GET_TWO_COLUMS_TEXT_LEFT_BY_SLUG,
    GET_TWO_COLUMS_TEXT_RIGHT_BY_SLUG,
    GET_VIDEO_BY_SLUG,
    GET_POSTS,
    GET_FOOTER,
    GET_THREE_COLUMNS_CARDS,
    GET_CAROUSELL_BY_SLUG,
    GET_POST_LIST,
    GET_POST_DETAIL,
    GET_PAYMENT_METHOD_SECTION,
    GET_MARKETS,
    GET_MARKET_PAYMENT_METHODS,
    GET_TWO_COLUMS_TEXT_BY_SLUG,
    GET_FORM_SECTION_BY_SLUG,
    GET_TWO_COLUMS_IMAGE_BY_SLUG,
    GET_TERMS_AND_CONDITIONS,
    GET_FAQS,
    GET_PRIVACY_POLICIES,
    GET_SEO_DATA,
    GET_FLOATING_BANNER
}